import React, { useRef, useState, useEffect } from "react";
import {
    I2cRadioGroup, I2cRadioButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { Controller } from "react-hook-form";
import { CheckboxRenderer, InputRenderer, CheckboxTableRenderer, HeaderCheckboxRenderer } from "./CellRenderer";
import { shippingMethod, loginInfo } from './stringUtils';
import { I2cDataTable } from '@webcomponents/i2cwebcomponents/dist/react';
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"

const ShippingMethod = ({ type, control, handleValueChanges, methods, errors, appSelectionForProgram, isFormDataUpdated }) => {
    const table = useRef();
    const [gridOptions, setGridOptions] = useState({});
    const [rowDataInitial, setRowDataInitial] = useState(shippingMethod || []);

    useEffect(() => {
        const backendData = methods.getValues('card_enrollment_shipping_method');
        if (backendData?.length > 0) {
            setGridOptions({
                columnDefs: [
                    { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer },
                    { headerName: 'Custom Menu Name', field: 'alternativeMethod', cellRenderer: InputRenderer }
                ],
                rowSelection: 'single',
                rowData: backendData, // Use data from the backend
                suppressMoveWhenRowDragging: true,
                context: { methods, handleValueChanges }
            });
        } else {
            setGridOptions({
                columnDefs: [
                    { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer },
                    { headerName: 'Custom Menu Name', field: 'alternativeMethod', cellRenderer: InputRenderer }
                ],
                rowSelection: 'single',
                rowData: rowDataInitial, // Fallback to initial data
                suppressMoveWhenRowDragging: true,
                context: { methods, handleValueChanges }
            });
        }
        // Ensure grid API updates
        const api = table?.current?.getGridApi();
        if (api) {
            api.setRowData && api.setRowData(backendData?.length > 0 ? backendData : rowDataInitial);
        }
    }, [isFormDataUpdated, methods.watch('card_enrollment_shipping_method')]);

    return (
        <>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Shipping Method
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <Controller
                        name="card_enrollment_shipping_method"
                        control={control}
                        render={({ field }) => (
                            <I2cDataTable
                                id="dataTable1"
                                ref={table}
                                gridOptionInput={gridOptions}
                                notFound={[
                                    {
                                        description:
                                            'No data available. Please add some features or refresh the page.',
                                        type: 'noData',
                                        icon: 'outline-info-circle',
                                        primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
                                    },
                                ]}
                            ></I2cDataTable>
                        )}
                    />
                </div>
            </div>
        </>
    );
};

export default ShippingMethod;                  
